var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29169 9.99984C1.29169 6.12258 1.29169 4.18396 2.38983 2.8982C2.54576 2.71562 2.71581 2.54558 2.89838 2.38964C4.18414 1.2915 6.12277 1.2915 10 1.2915C13.8773 1.2915 15.8159 1.2915 17.1017 2.38964C17.2842 2.54558 17.4543 2.71562 17.6102 2.8982C18.7084 4.18396 18.7084 6.12258 18.7084 9.99984C18.7084 13.8771 18.7084 15.8157 17.6102 17.1015C17.4543 17.2841 17.2842 17.4541 17.1017 17.61C15.8159 18.7082 13.8773 18.7082 10 18.7082C6.12277 18.7082 4.18414 18.7082 2.89838 17.61C2.71581 17.4541 2.54576 17.2841 2.38983 17.1015C1.29169 15.8157 1.29169 13.8771 1.29169 9.99984Z",
    stroke: "#253837",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.2847C12.3115 13.1129 11.5136 13.6668 10.6021 13.6668C9.21809 13.6668 8.09615 12.39 8.09615 10.815V9.18535C8.09615 7.61031 9.21809 6.3335 10.6021 6.3335C11.5136 6.3335 12.3115 6.8874 12.75 7.71559M7.25 10.0002H10.8462",
    stroke: "#253837",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwotone);
export default __webpack_public_path__ + "static/media/Twotone.244d7003f31a40dadd1febaa8315d9dd.svg";
export { ForwardRef as ReactComponent };